import { render, staticRenderFns } from "./QuickReplyMessageEditor.vue?vue&type=template&id=533c51b6"
import script from "./QuickReplyMessageEditor.vue?vue&type=script&lang=js"
export * from "./QuickReplyMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./QuickReplyMessageEditor.vue?vue&type=style&index=0&id=533c51b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports